import { render, staticRenderFns } from "./delta-overlay.vue?vue&type=template&id=7667f050&scoped=true&"
import script from "./delta-overlay.vue?vue&type=script&lang=js&"
export * from "./delta-overlay.vue?vue&type=script&lang=js&"
import style0 from "./delta-overlay.vue?vue&type=style&index=0&id=7667f050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7667f050",
  null
  
)

export default component.exports